module.exports = __webpack_public_path__ + "static/img/manual-44.0fa7232.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-44.png
// module id = plMS
// module chunks = 4